import { Component, Input } from '@angular/core';

@Component({
  selector: 'zikatagov-label',
  template: `
    <label [for]="for" class="form-label">
      <ng-content></ng-content>
    </label>
  `,
   standalone: true
})
export class ZikataLabelComponent {
  @Input() for = '';
}
